import { render } from "./ToiletsModule.vue?vue&type=template&id=ceb80d9e&scoped=true"
import script from "./ToiletsModule.vue?vue&type=script&lang=js"
export * from "./ToiletsModule.vue?vue&type=script&lang=js"

import "./ToiletsModule.vue?vue&type=style&index=0&id=ceb80d9e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ceb80d9e"

export default script